import { ItemList } from "../orm";
import { showSuccess } from "./error";

class ProcessGalleryPhotographsList extends ItemList {
  getEntityKey() {
    return "photographer/gallery/process_uploaded_photographs";
  }

  processGalleryPhotographs(galleryId) {
    return (dispatch, getState) => {
      dispatch(processGalleryPhotographsList.clearListFilter());
      dispatch(
        processGalleryPhotographsList.updateListFilter({
          gallery_id: galleryId,
        }),
      );
      dispatch(processGalleryPhotographsList.fetchListIfNeeded());
      showSuccess("Processing Gallery Photographs");
    };
  }
}

export const processGalleryPhotographsList = new ProcessGalleryPhotographsList(
  "process_gallery_photographs__default",
);
